import { uniqueKey } from 'global/common/keys'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { gameScoringTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import React, { useContext, useMemo } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import { matchFilterHelpers } from '../matches/MatchFilters'
import MotionDiv, { FadeWrapper } from 'global/motions/MotionDiv'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff'
import { useTeamRecords } from 'projectSpecific/sports/useHelpers/useTeamRecords'
import { _standingsViewTypes } from './SectionStandingz'
import { createInitials } from 'global/common/dataAdjust'
import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation'
import { TeamLabels } from './TeamLabels'

const _tris = {
  l: 'l',
  mr: 'mr',
  n: 'n',
  nsl: 'nsl',
  nst: 'nst',
  nsw: 'nsw',
  op: 'op',
  p: 'p',
  sl: 'sl',
  smr: 'smr',
  sp: 'sp',
  st: 'st',
  sw: 'sw',
  t: 't',
  w: 'w',
}

export const _teamNames = ['Catholic', 'Christian', 'Academy', 'County', 'McMillan', 'Bradock Hills', 'Township']
export const _teamNamesReplace = ['Cath.', 'Christ.', 'Acad.', 'Co.', 'Mac', 'BH', 'Twp.']

export const TeamSectionRecord = ({
  forPlayoff,
  handleTeamClick,
  isNonSection,
  rowKey,
  standingsViewType,
  tableType,
  team_favs,
  team,
  valueW,
}) => {

  const upn = usePageNavigation()

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, sportsSeason_info, sportSettings_info, matches_info } = sportsSeason_state ?? {}
  const { showRankingsInStandings } = sportSettings_info ?? {}
  const { showMatchesRemainingCount } = sportsSeason_info ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { playoffLevel, playoffLevelTeams } = playoff_info ?? {}

  const teams_playoffGroup = playoffLevelTeams?.[playoffLevel]
  const tpgs = teams_playoffGroup ? _.size(teams_playoffGroup) : 0

  const { matches, matches_playoffs } = matches_info ?? {}

  const handleMatchClick = (e, teamMatch) => {
    e.stopPropagation()
    upn.handleNav_item({ key: 'matches' }, teamMatch._itemKey)
  }

  let cellCount = 0

  const label_currentRank = (currentRank) => <Label size={'mini'} className={'team-rank'} circular>{currentRank}</Label>
  const label_section = (sectionRank) => <Label size='mini'>{sectionRank}</Label>
  const label_matchesRemaining = (smr, mr) => <Label size='mini' className='sssmr' title={'Remaining (section:all)'}>
    <Icon name='caret right' />{smr}{':'}{mr}
  </Label>

  const icon_fav = () => <Icon className={'ssfav'} name={'star'} color={'blue'} size={'tiny'} />

  const recordDiv = (t, value, width) => {
    cellCount++
    return <div className={`trr-${t}`} key={uniqueKey('ss', 'rc', cellCount)} >{value}</div>
  }

  const teamRecordDiv = (record) => {

    let trs = []

    const cells = []

    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:
      case gameScoringTypes.inning:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl]
            } else {
              trs = [_tris.sw, _tris.sl]
            }
            if (gameScoringType === gameScoringTypes.matchPoints) {
              trs.push(_tris.p)
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            if (gameScoringType === gameScoringTypes.matchPoints) {
              trs.push(_tris.op)
            }
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;

      case gameScoringTypes.half:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst, _tris.nsp]
            } else {
              trs = [_tris.sw, _tris.sl, _tris.st, _tris.sp]
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            trs.push(_tris.t)
            trs.push(_tris.op)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;

      case gameScoringTypes.quarter:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst]
            } else {
              if (gameAllowTies) {
                trs = [_tris.sw, _tris.sl, _tris.st]
              } else {
                trs = [_tris.sw, _tris.sl]
              }
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            gameAllowTies && trs.push(_tris.t)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              gameAllowTies && trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              gameAllowTies && trs.push(_tris.n)
            }
          }
        }
        break;

      default:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst, _tris.nsp]
            } else {
              trs = [_tris.sw, _tris.sl, _tris.st, _tris.sp]
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            trs.push(_tris.t)
            trs.push(_tris.op)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;
    }

    trs.forEach(t => {
      switch (t) {
        case _tris.n:
          cells.push(recordDiv(t, 0, valueW))
          break;
        default:
          cells.push(recordDiv(t, record?.[t], valueW))
      }

    })

    return cells
  }

  const content_row = (record) => {
    switch (standingsViewType) {
      case _standingsViewTypes.bestWins:
      case _standingsViewTypes.form:
      case _standingsViewTypes.full:
      case _standingsViewTypes.insights:
      case _standingsViewTypes.remaining:
      case _standingsViewTypes.worstLosses:
      case _standingsViewTypes.vs:
      case _standingsViewTypes.nonSection:
        return teamRecordDiv(record)
    }
  }

  const standingsTeamRow = useMemo(() => {

    const { name, record, _itemKey, currentRank, teamNumber } = team ?? {}
    const { display, playoffTeam, nonPlayoffTeam, playoffEliminated, playoffAssured, sectionRank, smr, mr, tmm, _inactive } = record ?? {}

    const playoffTeamCompare = false // playoffTeamCompares && team ? _.find(playoffTeamCompares, { id: team._itemKey }) : null

    const _name = teamName(name)

    const isFav = team_favs && team_favs[_itemKey] ? true : false
    let _rowCn = 'standing-team smr'
    _rowCn += isFav ? ' fav' : ''
    _rowCn += gameScoringType === gameScoringTypes.matchPoints ? ' pts' : ''

    if (playoffTeamCompare) { _rowCn += ' ptc' }

    if (isNonSection && 1 === 3) {
      return <div key={uniqueKey('ss', 'sr', rowKey)} className={_rowCn}>
        <div>{index + 1}</div>
        <div>{'#' + teamNumber}</div>
        <div>{_name}</div>
      </div>
    } else {

      // adjust the class for the row
      if (playoffTeam) { _rowCn += ' ss-pt' }
      if (nonPlayoffTeam) { _rowCn += ' ss-npt' }
      if (playoffEliminated) { _rowCn += ' ss-npte' }
      if (playoffAssured) { _rowCn += ' ss-npta' }
      if (tmm && tmm > 0) { _rowCn += ' ss-mm' }
      if (_inactive) { _rowCn += ' t-mia' }
      if (standingsViewType) { _rowCn += ' svt-full' }

      const _playoffTeam = teams_playoffGroup ? _.find(teams_playoffGroup, { _itemKey }) : null
      if (_playoffTeam) { _rowCn += ' ptm' }

      // trr-team and trs remaining are sub divs
      return <div key={uniqueKey('ss', 'sr', rowKey)} className={_rowCn} onClick={(e) => handleTeamClick(e, team)}>
        <div className={`trr-team`}>
          <Label size='mini'>{sectionRank}</Label>
          {_name}
          {/* {content_display(display)} */}
          {isFav && icon_fav()}
          {showRankingsInStandings && currentRank && label_currentRank(currentRank)}
          {!forPlayoff && (mr > 0) && showMatchesRemainingCount > smr && label_matchesRemaining(smr, mr)}
          {forPlayoff && label_section(sectionRank)}
        </div>
        {content_row(record)}
      </div>
    }
  }, [standingsViewType, gameScoringType, team?.record])

  const additionalTeamRow = useMemo(() => {
    return <TeamLabels
      standingsViewType={standingsViewType}
      team={team}
      matches={matches}
      handleMatchClick={handleMatchClick}
    />
  })

  return <FadeWrapper>
    {standingsTeamRow}
    {additionalTeamRow}
  </FadeWrapper>

}

const teamName = (name) => {
  if (!name) return name;
  let _name = name
  for (let i = 0; i < _teamNames.length; i++) {
    if (name.includes(_teamNames[i])) {
      _name = name.replace(_teamNames[i], _teamNamesReplace[i]);
    }
  }
  return _name
}
